(() => {
  const initBeatsTable = () => {
    const list = document.getElementById("beats-list");
    const searchInput = document.getElementById("beats-search");
    const searchClear = document.getElementById("beatSearchClear");
    const bpmFilterWrapper = document.getElementById("beatBpmFilterWrapper");
    const bpmFilterTrigger = document.getElementById("beatBpmFilterTrigger");
    const bpmFilterDisplay = document.getElementById("beatBpmFilterDisplay");
    const bpmFilterMenu = document.getElementById("beatBpmFilterMenu");
    const bpmFilterOptions = Array.from(document.querySelectorAll("[data-bpm-option]"));
    const tagFilterWrapper = document.getElementById("beatTagFilterWrapper");
    const tagFilterTrigger = document.getElementById("beatTagFilterTrigger");
    const tagFilterDisplay = document.getElementById("beatTagFilterDisplay");
    const tagFilterMenu = document.getElementById("beatTagFilterMenu");
    const tagFilterOptions = Array.from(document.querySelectorAll("[data-tag-option]"));
    const sortFilterWrapper = document.getElementById("beatSortFilterWrapper");
    const sortFilterTrigger = document.getElementById("beatSortFilterTrigger");
    const sortFilterDisplay = document.getElementById("beatSortFilterDisplay");
    const sortFilterMenu = document.getElementById("beatSortFilterMenu");
    const sortFilterOptions = Array.from(document.querySelectorAll("[data-sort-option]"));
    const emptyState = document.getElementById("beats-empty-state");
    const resetButton = document.getElementById("beatsResetFilters");
    const loadMoreButton = document.getElementById("load-more-btn");
    const loadAllButton = document.getElementById("load-all-btn");
    const rows = Array.from(document.querySelectorAll(".beat-item"));
    const shareButtons = Array.from(document.querySelectorAll(".js-share"));

    if (
      !list ||
      !searchInput ||
      !searchClear ||
      !bpmFilterWrapper ||
      !bpmFilterTrigger ||
      !bpmFilterDisplay ||
      !bpmFilterMenu ||
      !bpmFilterOptions.length ||
      !tagFilterWrapper ||
      !tagFilterTrigger ||
      !tagFilterDisplay ||
      !tagFilterMenu ||
      !tagFilterOptions.length ||
      !sortFilterWrapper ||
      !sortFilterTrigger ||
      !sortFilterDisplay ||
      !sortFilterMenu ||
      !sortFilterOptions.length ||
      !emptyState ||
      !resetButton ||
      !loadMoreButton ||
      !loadAllButton ||
      !rows.length
    ) {
      return;
    }

    const INITIAL_VISIBLE_COUNT = 8;
    const DEFAULT_SORT_FILTER = "date-desc";
    let visibleCount = INITIAL_VISIBLE_COUNT;
    let activeBpmFilter = "all";
    let activeSortFilter = DEFAULT_SORT_FILTER;
    let selectedSortFilter = "";
    const activeTagFilters = new Set();

    const rowState = rows.map((row, index) => {
      const bpmText = row.dataset.bpm || "";
      const bpm = Number.parseFloat(bpmText);
      const createdDate = Number.parseInt(row.dataset.createdDate || "", 10) || 0;
      const title = (row.dataset.title || "").toLowerCase();
      let tags = [];

      try {
        tags = JSON.parse(row.dataset.tags || "[]")
          .map((tag) => `${tag}`.trim().toLowerCase())
          .filter(Boolean);
      } catch (error) {
        tags = [];
      }

      return {
        row,
        index,
        title,
        bpm,
        createdDate,
        tags,
      };
    });

    const customFilters = [
      {
        key: "bpm",
        wrapper: bpmFilterWrapper,
        trigger: bpmFilterTrigger,
        display: bpmFilterDisplay,
        menu: bpmFilterMenu,
        options: bpmFilterOptions,
        valueAttribute: "bpmOption",
        mountParent: bpmFilterWrapper,
        frame: null,
        closeTimer: null,
      },
      {
        key: "tags",
        wrapper: tagFilterWrapper,
        trigger: tagFilterTrigger,
        display: tagFilterDisplay,
        menu: tagFilterMenu,
        options: tagFilterOptions,
        valueAttribute: "tagOption",
        mountParent: tagFilterWrapper,
        frame: null,
        closeTimer: null,
      },
      {
        key: "sort",
        wrapper: sortFilterWrapper,
        trigger: sortFilterTrigger,
        display: sortFilterDisplay,
        menu: sortFilterMenu,
        options: sortFilterOptions,
        valueAttribute: "sortOption",
        mountParent: sortFilterWrapper,
        frame: null,
        closeTimer: null,
      },
    ];

    const updateCustomFilterMenuPosition = (filter) => {
      const triggerRect = filter.trigger.getBoundingClientRect();

      filter.menu.style.setProperty("--beat-custom-filter-menu-top", `${triggerRect.bottom + 10}px`);
      filter.menu.style.setProperty("--beat-custom-filter-menu-left", `${triggerRect.left}px`);
      filter.menu.style.setProperty("--beat-custom-filter-menu-width", `${triggerRect.width}px`);
    };

    const queueCustomFilterMenuPosition = (filter) => {
      if (filter.menu.hidden || filter.frame !== null) {
        return;
      }

      filter.frame = window.requestAnimationFrame(() => {
        filter.frame = null;
        updateCustomFilterMenuPosition(filter);
      });
    };

    const mountCustomFilterMenu = (filter) => {
      if (filter.menu.parentElement === document.body) {
        return;
      }

      document.body.appendChild(filter.menu);
      updateCustomFilterMenuPosition(filter);
    };

    const unmountCustomFilterMenu = (filter) => {
      if (filter.menu.parentElement === filter.mountParent) {
        return;
      }

      filter.mountParent.appendChild(filter.menu);
    };

    const closeOtherMenus = (currentKey) => {
      customFilters.forEach((filter) => {
        if (filter.key !== currentKey) {
          setCustomFilterOpen(filter, false);
        }
      });
    };

    const setCustomFilterOpen = (filter, isOpen) => {
      if (isOpen) {
        if (filter.closeTimer) {
          window.clearTimeout(filter.closeTimer);
          filter.closeTimer = null;
        }

        closeOtherMenus(filter.key);
        mountCustomFilterMenu(filter);
        updateCustomFilterMenuPosition(filter);
      }

      filter.wrapper.classList.toggle("is-open", isOpen);
      filter.trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
      if (isOpen) {
        filter.menu.hidden = false;
        filter.menu.classList.remove("is-open");
        filter.menu.getBoundingClientRect();

        window.requestAnimationFrame(() => {
          filter.menu.classList.add("is-open");
        });

        return;
      }

      filter.menu.classList.remove("is-open");

      if (filter.closeTimer) {
        window.clearTimeout(filter.closeTimer);
      }

      filter.closeTimer = window.setTimeout(() => {
        filter.menu.hidden = true;
        unmountCustomFilterMenu(filter);
        filter.closeTimer = null;
      }, 220);
    };

    const syncBpmFilterOptions = () => {
      bpmFilterOptions.forEach((option) => {
        option.classList.toggle("is-active", (option.dataset.bpmOption || "") === activeBpmFilter);
      });
    };

    const syncTagFilterOptions = () => {
      tagFilterOptions.forEach((option) => {
        const value = option.dataset.tagOption?.toLowerCase() || "";
        const isAll = value === "all";
        const isActive = isAll ? activeTagFilters.size === 0 : activeTagFilters.has(value);

        option.classList.toggle("is-active", isActive);
      });
    };

    const syncSortFilterOptions = () => {
      sortFilterOptions.forEach((option) => {
        option.classList.toggle("is-active", (option.dataset.sortOption || "") === selectedSortFilter);
      });
    };

    const syncTagSelection = () => {
      rows.forEach((row) => {
        row.querySelectorAll(".beat-tag").forEach((tag) => {
          const isActive = activeTagFilters.has(tag.dataset.tagValue?.toLowerCase() || "");
          tag.classList.toggle("is-active", isActive);
        });
      });
    };

    const updateFilterDisplays = () => {
      const activeBpmOption = bpmFilterOptions.find((option) => option.dataset.bpmOption === activeBpmFilter);
      bpmFilterDisplay.textContent = activeBpmOption ? activeBpmOption.textContent.trim() : (tagFilterDisplay.dataset.allBpmLabel || "All BPM");

      if (activeTagFilters.size === 0) {
        tagFilterDisplay.textContent = tagFilterDisplay.dataset.allLabel || "All tags";
      } else if (activeTagFilters.size === 1) {
        tagFilterDisplay.textContent = Array.from(activeTagFilters)[0];
      } else {
        tagFilterDisplay.textContent = (tagFilterDisplay.dataset.manyLabel || "__N__ tags").replace("__N__", activeTagFilters.size);
      }

      const activeSortOption = sortFilterOptions.find((option) => option.dataset.sortOption === selectedSortFilter);
      sortFilterDisplay.textContent = activeSortOption ? activeSortOption.textContent.trim() : (tagFilterDisplay.dataset.sortLabel || "Sort by");
    };

    const getFilteredRows = () => {
      const query = searchInput.value.trim().toLowerCase();
      const selectedTags = Array.from(activeTagFilters);

      const filtered = rowState.filter((entry) => {
        const matchesQuery =
          !query ||
          entry.title.includes(query) ||
          entry.tags.some((tag) => tag.includes(query));

        let matchesBpm = true;
        if (activeBpmFilter !== "all") {
          const selectedBpmOption = bpmFilterOptions.find((option) => option.dataset.bpmOption === activeBpmFilter);
          const min = Number.parseFloat(selectedBpmOption?.dataset.min || "");
          const max = Number.parseFloat(selectedBpmOption?.dataset.max || "");
          matchesBpm = Number.isFinite(entry.bpm) && entry.bpm >= min && entry.bpm <= max;
        }

        const matchesTag = selectedTags.length === 0 || selectedTags.every((tag) => entry.tags.includes(tag));

        return matchesQuery && matchesBpm && matchesTag;
      });

      if (activeSortFilter === "date-desc") {
        filtered.sort((left, right) => right.createdDate - left.createdDate || left.index - right.index);
      } else if (activeSortFilter === "bpm-asc") {
        filtered.sort((left, right) => {
          const leftBpm = Number.isFinite(left.bpm) ? left.bpm : Number.POSITIVE_INFINITY;
          const rightBpm = Number.isFinite(right.bpm) ? right.bpm : Number.POSITIVE_INFINITY;
          return leftBpm - rightBpm || left.index - right.index;
        });
      } else if (activeSortFilter === "bpm-desc") {
        filtered.sort((left, right) => {
          const leftBpm = Number.isFinite(left.bpm) ? left.bpm : Number.NEGATIVE_INFINITY;
          const rightBpm = Number.isFinite(right.bpm) ? right.bpm : Number.NEGATIVE_INFINITY;
          return rightBpm - leftBpm || left.index - right.index;
        });
      } else if (activeSortFilter === "title-asc") {
        filtered.sort((left, right) => left.title.localeCompare(right.title) || left.index - right.index);
      } else {
        filtered.sort((left, right) => right.createdDate - left.createdDate || left.index - right.index);
      }

      return filtered;
    };

    const applyFilters = () => {
      const filteredRows = getFilteredRows();
      const filteredSet = new Set(filteredRows.map((entry) => entry.row));
      const orderedRows = [
        ...filteredRows.map((entry) => entry.row),
        ...rowState.filter(({ row }) => !filteredSet.has(row)).map(({ row }) => row),
      ];

      orderedRows.forEach((row) => {
        list.appendChild(row);
      });

      rowState.forEach(({ row }) => {
        row.hidden = true;
      });

      filteredRows.forEach((entry, index) => {
        entry.row.hidden = index >= visibleCount;
      });

      const hasResults = filteredRows.length > 0;
      list.hidden = !hasResults;
      emptyState.hidden = hasResults;

      const canLoadMore = filteredRows.length > visibleCount;
      loadMoreButton.hidden = !hasResults || !canLoadMore;
      loadAllButton.hidden = !hasResults || !canLoadMore;
      loadMoreButton.disabled = false;
      loadAllButton.disabled = false;

      if (!hasResults) {
        loadMoreButton.hidden = true;
        loadAllButton.hidden = true;
      }

      syncBpmFilterOptions();
      syncTagSelection();
      syncTagFilterOptions();
      syncSortFilterOptions();
      updateFilterDisplays();

      rowState.forEach(({ row }) => {
        if (!filteredSet.has(row)) {
          row.classList.remove("is-active");
        }
      });
    };

    const toggleTagFilterValue = (rawValue) => {
      const tagValue = rawValue?.trim().toLowerCase();
      if (!tagValue) return;

      if (tagValue === "all") {
        activeTagFilters.clear();
      } else if (activeTagFilters.has(tagValue)) {
        activeTagFilters.delete(tagValue);
      } else {
        activeTagFilters.add(tagValue);
      }

      visibleCount = INITIAL_VISIBLE_COUNT;
      applyFilters();
    };

    const setSingleFilterValue = (filterKey, rawValue) => {
      if (filterKey === "bpm") {
        activeBpmFilter = rawValue || "all";
      } else if (filterKey === "sort") {
        selectedSortFilter = rawValue || "";
        activeSortFilter = rawValue || DEFAULT_SORT_FILTER;
      }

      visibleCount = INITIAL_VISIBLE_COUNT;
      applyFilters();
    };

    const resetFilters = () => {
      searchInput.value = "";
      searchClear.classList.remove("show");
      activeBpmFilter = "all";
      activeTagFilters.clear();
      activeSortFilter = DEFAULT_SORT_FILTER;
      selectedSortFilter = "";
      customFilters.forEach((filter) => {
        setCustomFilterOpen(filter, false);
      });
      visibleCount = INITIAL_VISIBLE_COUNT;
      applyFilters();
    };

    const flashShareState = (button, label) => {
      if (!button) return;

      const previousLabel = button.getAttribute("aria-label") || "Share beat";
      button.setAttribute("aria-label", label);
      button.classList.add("is-feedback");

      window.setTimeout(() => {
        button.setAttribute("aria-label", previousLabel);
        button.classList.remove("is-feedback");
      }, 1400);
    };

    const shareBeat = async (button) => {
      const shareUrl = button.dataset.share || button.dataset.url;
      if (!shareUrl) return;

      const shareTitle =
        button.closest(".beat-item")?.dataset.title ||
        document.title ||
        "Beat";

      if (navigator.share) {
        try {
          await navigator.share({
            title: shareTitle,
            url: shareUrl,
          });
          return;
        } catch (error) {
          if (error?.name === "AbortError") {
            return;
          }
        }
      }

      if (navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(shareUrl);
          flashShareState(button, "Link copied");
          return;
        } catch (error) {
          // Fall through to legacy copy below.
        }
      }

      const temporaryInput = document.createElement("input");
      temporaryInput.type = "text";
      temporaryInput.value = shareUrl;
      temporaryInput.setAttribute("readonly", "");
      temporaryInput.style.position = "fixed";
      temporaryInput.style.opacity = "0";
      document.body.appendChild(temporaryInput);
      temporaryInput.select();
      document.execCommand("copy");
      document.body.removeChild(temporaryInput);
      flashShareState(button, "Link copied");
    };

    searchInput.addEventListener("input", () => {
      visibleCount = INITIAL_VISIBLE_COUNT;
      searchClear.classList.toggle("show", searchInput.value.trim().length > 0);
      applyFilters();
    });

    searchClear.addEventListener("click", () => {
      searchInput.value = "";
      searchInput.focus();
      searchClear.classList.remove("show");
      visibleCount = INITIAL_VISIBLE_COUNT;
      applyFilters();
    });

    resetButton.addEventListener("click", resetFilters);

    loadMoreButton.addEventListener("click", () => {
      visibleCount += INITIAL_VISIBLE_COUNT;
      applyFilters();
    });

    loadAllButton.addEventListener("click", () => {
      visibleCount = Number.MAX_SAFE_INTEGER;
      applyFilters();
    });

    customFilters.forEach((filter) => {
      filter.trigger.addEventListener("click", () => {
        setCustomFilterOpen(filter, filter.menu.hidden);
      });

      filter.menu.addEventListener("click", (event) => {
        event.stopPropagation();
      });
    });

    bpmFilterOptions.forEach((option) => {
      option.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        setSingleFilterValue("bpm", option.dataset.bpmOption);
        setCustomFilterOpen(customFilters[0], false);
      });
    });

    tagFilterOptions.forEach((option) => {
      option.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleTagFilterValue(option.dataset.tagOption);
      });
    });

    sortFilterOptions.forEach((option) => {
      option.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        setSingleFilterValue("sort", option.dataset.sortOption);
        setCustomFilterOpen(customFilters[2], false);
      });
    });

    shareButtons.forEach((button) => {
      button.addEventListener("click", async (event) => {
        event.preventDefault();
        event.stopPropagation();
        await shareBeat(button);
      });
    });

    document.addEventListener("click", (event) => {
      const tag = event.target.closest(".beat-tag");
      if (tag) {
        event.preventDefault();
        event.stopPropagation();
        toggleTagFilterValue(tag.dataset.tagValue);
        return;
      }

      customFilters.forEach((filter) => {
        if (!filter.wrapper.contains(event.target) && !filter.menu.contains(event.target)) {
          setCustomFilterOpen(filter, false);
        }
      });
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        customFilters.forEach((filter) => {
          setCustomFilterOpen(filter, false);
        });
      }
    });

    window.addEventListener("resize", () => {
      customFilters.forEach((filter) => {
        queueCustomFilterMenuPosition(filter);
      });
    });

    window.addEventListener(
      "scroll",
      () => {
        customFilters.forEach((filter) => {
          queueCustomFilterMenuPosition(filter);
        });
      },
      { passive: true }
    );

    applyFilters();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBeatsTable, { once: true });
  } else {
    initBeatsTable();
  }
})();
